import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { forwardRef, useState, Fragment } from 'react';
import suggestionData from '../../helpers/suggestion-data';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Triangle = _jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Triangle",
  viewBox: "0 0 19.8 12",
  height: "12",
  children: [_jsx("defs", {}), _jsx("path", {
    fill: "#b9b9b9",
    d: "M9.9 0L6.7 3.6.5 10.4 0 11h1.4l.4-.5 5.3-5.9 2.8-3.1 8.6 9.5h1.3L9.9 0z"
  }), _jsx("path", {
    fill: "#fff",
    d: "M18.5 11L9.9 1.5 7.1 4.6l-5.3 5.9-.4.5H0v1h19.8v-1h-1.3z"
  })]
});

var SuggestionBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      itemIsSelected = _useState4[0],
      setItemIsSelected = _useState4[1];

  var possibleMatches = [];

  var onChange = function onChange(e) {
    setItemIsSelected(false);
    setInputValue(e.target.value);
  };

  if (inputValue.length) {
    possibleMatches = suggestionData[props.suggestionData].filter(function (provider) {
      return provider.substr(0, inputValue.length).toLowerCase() === inputValue.toLowerCase();
    });
  }

  return _jsxs(Fragment, {
    children: [_jsx("div", {
      sx: {
        variant: 'elements.simple-input.wrapper'
      },
      children: _jsx("label", {
        sx: {
          display: 'block',
          mr: 'md',
          width: '100%'
        },
        children: _jsx("input", {
          type: "input",
          name: props.name,
          placeholder: props.placeholder,
          onChange: onChange,
          ref: ref,
          sx: {
            position: 'relative',
            variant: 'elements.simple-input.base'
          },
          value: inputValue,
          autoComplete: "off"
        })
      })
    }), _jsx("div", {
      sx: {
        display: possibleMatches.length ? 'block' : 'none'
      },
      children: _jsxs("ul", {
        sx: {
          display: itemIsSelected ? 'none' : 'block',
          position: 'relative',
          border: '1px solid #B9B9BD',
          mt: 'sm',
          pl: 'sm',
          zIndex: '999',
          bg: 'white',
          color: 'black'
        },
        children: [_jsx("p", {
          sx: {
            fontWeight: '700',
            p: '0'
          },
          children: "Your current provider"
        }), _jsx("div", {
          sx: {
            position: 'absolute',
            top: '-17px',
            zIndex: '1000'
          },
          children: Triangle
        }), possibleMatches.map(function (pm) {
          return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
            _jsx("li", {
              sx: {
                cursor: 'pointer',
                listStyle: 'none',
                lineHeight: 'md'
              },
              onClick: function onClick() {
                setItemIsSelected(true);
                setInputValue(pm);
              },
              children: pm
            }, pm)
          );
        })]
      })
    })]
  });
});
export default SuggestionBox;
//# sourceMappingURL=index.js.map